import './PlayerAvatar.css';

export default function PlayerAvatar({
  player,
  isDealer = false,
  isReady = false,
  isSittingOut = false,
  isSitOutQueued = false,
  size = 'normal', // 'small' | 'normal' | 'large'
}) {
  const classes = [
    'player-avatar',
    `player-avatar--${size}`,
    isDealer && 'player-avatar--dealer',
    isSittingOut && 'player-avatar--sitting-out',
    isSitOutQueued && 'player-avatar--sit-out-queued',
  ].filter(Boolean).join(' ');

  const avatarSrc = player.avatar
    ? `${process.env.PUBLIC_URL}/avatars/${player.avatar}`
    : `${process.env.PUBLIC_URL}/avatars/fish.jpg`;

  return (
    <div className={classes}>
      <div className="player-avatar__frame">
        <img
          src={avatarSrc}
          alt={player.displayName}
          className="player-avatar__img"
        />
        {isDealer && <span className="player-avatar__dealer-badge">D</span>}
        {isReady && <span className="player-avatar__ready-light" />}
      </div>
      <span className="player-avatar__name">{player.displayName}</span>
      {isSittingOut && <span className="player-avatar__status">Sitting Out</span>}
      {isSitOutQueued && !isSittingOut && (
        <span className="player-avatar__status player-avatar__status--queued">
          Sitting out next hand
        </span>
      )}
    </div>
  );
}
